module.exports = __webpack_public_path__ + "img/FounderStage.060b17b1.png";